// Snowfall (Christmas page POC, owner 2 Nov 2026): a short flurry over each canvas[data-snowfall], once per page load.
// Starts a second after load, snows for a few seconds, then the last flakes fade and the canvas is removed. Visitors
// who reduce motion get no snow: the canvas is removed straight away.
const START_DELAY = 1000; // ms after load
const SNOW_FOR = 4500; // ms of new flakes
const FADE_FOR = 1800; // ms for the last flakes to fade
const RAMP = 800; // ms to build up to full snowfall
const DENSITY = 1 / 2600; // flakes per second, per px² of canvas

function flurry(canvas) {
  const ctx = canvas.getContext('2d');
  if (!ctx) return canvas.remove();
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  let width = 0;
  let height = 0;
  const resize = () => {
    width = canvas.clientWidth;
    height = canvas.clientHeight;
    canvas.width = Math.round(width * dpr);
    canvas.height = Math.round(height * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  };
  resize();
  window.addEventListener('resize', resize);

  const flakes = [];
  const spawn = () => {
    const r = 1 + Math.random() ** 2 * 3; // mostly small, a few big ones
    flakes.push({
      x: Math.random() * width,
      y: -r * 2,
      r,
      speed: 40 + r * 28 + Math.random() * 30, // bigger = nearer = faster
      sway: 8 + Math.random() * 18,
      phase: Math.random() * Math.PI * 2,
      freq: 0.6 + Math.random() * 0.9,
      alpha: 0.55 + Math.random() * 0.4,
    });
  };

  let start = 0;
  let last = 0;
  let owed = 0;
  const frame = now => {
    if (!start) start = last = now;
    const t = now - start;
    const dt = Math.min((now - last) / 1000, 0.05);
    last = now;

    if (t < SNOW_FOR) {
      owed += width * height * DENSITY * dt * Math.min(t / RAMP, 1);
      for (; owed >= 1; owed -= 1) spawn();
    }
    const fade = t < SNOW_FOR ? 1 : Math.max(1 - (t - SNOW_FOR) / FADE_FOR, 0);

    ctx.clearRect(0, 0, width, height);
    ctx.fillStyle = '#fff';
    for (let i = flakes.length - 1; i >= 0; i -= 1) {
      const f = flakes[i];
      f.y += f.speed * dt;
      if (f.y - f.r > height) {
        flakes.splice(i, 1);
        continue;
      }
      const x = f.x + Math.sin(f.phase + (t / 1000) * f.freq * Math.PI * 2) * f.sway;
      ctx.globalAlpha = f.alpha * fade;
      ctx.beginPath();
      ctx.arc(x, f.y, f.r, 0, Math.PI * 2);
      ctx.fill();
    }

    if (fade > 0 && (t < SNOW_FOR || flakes.length)) {
      window.requestAnimationFrame(frame);
    } else {
      window.removeEventListener('resize', resize);
      canvas.remove();
    }
  };
  window.requestAnimationFrame(frame);
}

const canvases = document.querySelectorAll('canvas[data-snowfall]');
if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  canvases.forEach(canvas => canvas.remove());
} else {
  setTimeout(() => canvases.forEach(flurry), START_DELAY);
}
